<!-- begin:: Brand -->
<div class="kt-aside__brand kt-grid__item" [ngClass]="htmlClassService.getClasses('brand', true)" id="kt_aside_brand">
    <div class="kt-aside__brand-logo">
        <a href="javascript:;" routerLink="/demo1">
            <!-- <img src="../../../.././assets/media/logos/etloob-logo.svg" style="width: 12em;"/> -->
            <img src="../../../.././assets/media/logos/Untitled-4-croped.png" style="width: 14em; height: auto;"/>
        </a>
    </div>
    <div class="kt-aside__brand-tools">
        <button KtToggle [options]="toggleOptions" class="kt-aside__brand-aside-toggler kt-aside__brand-aside-toggler--left" id="kt_aside_toggler">
            <img [src]="'./assets/media/icons/svg/Navigation/Angle-double-left.svg'"/>
            <img [src]="'./assets/media/icons/svg/Navigation/Angle-double-right.svg'"/>
        </button>
    </div>
</div>
<!-- end:: Brand -->

